import { ChevronLeft, ChevronRight } from "lucide-react";
import { useTranslation } from "@/i18n/LanguageContext";

/**
 * Footer for paginated endpoints returning {items,total,limit,offset}.
 */
export default function Pager({ total, limit, offset, onChange, testId = "pager" }) {
  const t = useTranslation();
  const from = total === 0 ? 0 : offset + 1;
  const to = Math.min(offset + limit, total);
  const canPrev = offset > 0;
  const canNext = offset + limit < total;

  return (
    <div
      className="mt-3 flex flex-col gap-3 text-[11px] font-mono text-muted-foreground sm:flex-row sm:items-center sm:justify-between"
      data-testid={testId}
    >
      <span>
        {t("common.pager.range", { from, to, total })}
      </span>
      <div className="flex flex-wrap items-center gap-2">
        <button
          type="button"
          className="inline-flex h-8 items-center gap-1 rounded-lg border border-border px-2 disabled:opacity-40 hover:border-foreground/40"
          disabled={!canPrev}
          data-testid={`${testId}-prev`}
          onClick={() => onChange({ offset: Math.max(0, offset - limit), limit })}
        >
          <ChevronLeft className="h-3.5 w-3.5" /> {t("common.pager.prev")}
        </button>
        <button
          type="button"
          className="inline-flex h-8 items-center gap-1 rounded-lg border border-border px-2 disabled:opacity-40 hover:border-foreground/40"
          disabled={!canNext}
          data-testid={`${testId}-next`}
          onClick={() => onChange({ offset: offset + limit, limit })}
        >
          {t("common.pager.next")} <ChevronRight className="h-3.5 w-3.5" />
        </button>
        <select
          value={limit}
          onChange={(e) => onChange({ offset: 0, limit: Number(e.target.value) })}
          data-testid={`${testId}-page-size`}
          className="h-8 rounded-lg border border-border bg-background px-1"
        >
          {[10, 25, 50, 100].map((n) => (
            <option key={n} value={n}>{t("common.pager.perPage", { count: n })}</option>
          ))}
        </select>
      </div>
    </div>
  );
}
